<template>
    <div class="AssumptionInput">
        <label class="AssumptionInput__label" :for="id">
            <slot />
        </label>
        <div class="AssumptionInput__input-wrap" :class="{'error' : validation.$invalid}">
            <MoneyInput 
                v-if="isMoney"
                :value="value"
                :id="id"
                :error="validation.$invalid ? error : ''"
                @input="$emit('input', $event.target.value)"
            />
            <input 
                v-else
                class="AssumptionInput__input"
                :value="value"
                :type="type"
                :id="id"
                @input="$emit('input', $event.target.value)"
                :aria-label="validation.$invalid && error"
            >
        </div>
    </div>
</template>

<script>
import MoneyInput from '@/components/MoneyInput';

export default {
    data: () => ({
        id: Math.floor(Math.random() * 10000)
    }),

    components: {
        MoneyInput
    },

    props: {
        value: {
            type: [Number, String],
            required: true
        },
        isMoney: {
            type: Boolean,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        },
        error: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss">
    .AssumptionInput {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 25px;
    }

    .AssumptionInput__label {
        max-width: 280px;
        text-align: left;
        line-height: 1.3em;
        font-family: 'AtlasGrotesk-Medium-Web', Helvetica, Arial, sans-serif;
    }
    .AssumptionInput__input-money {
        position: absolute;
        left: 8px;
        top: -2px;
    }

    .AssumptionInput__input {
        width: 100%;
        border: none;
        border-bottom: 1px solid #dcdcdc;
        outline: none;
        padding-bottom: 5px;
        padding-left: 5px;
        padding-right: 15px;
        margin: 0 3px;
        background-color: transparent;
        text-align: right;
        font-size: 16px;
        border-radius: 0;
    }

    .AssumptionInput__input-wrap {
        position: relative;
        display: flex;
        flex-shrink: 0;
        width: 130px;
        margin-left: 10px;

        @media screen and (min-width: 768px) {
            width: 150px;
        }

        &.error:after {
            content: 'Please enter a valid input';
            width: 120px;
            position: absolute;
            font-size: 10px;
            color:  #f72525;
            bottom: -20px;
        }
    }

    .AssumptionInput__input-money ~ .AssumptionInput__input {
        padding-left: 20px;
    }

    .error {
        border: 1px solid red;
        border-radius: 4px;
    }

    input::-webkit-outer-spin-button, 
    input::-webkit-inner-spin-button { 
        margin-left: 10px; 
    } 
</style>
